interface LocationParam {
  address1: string
  address2?: string | null
  city: string
  state: string
  zipcode: string
}

function normalizeState(state: string): string {
  // "CN" is International Canada
  // "XX" is Unknown/Unspecified State
  // See https://github.toasttab.com/toasttab/toastweb/blob/9ee4734a94697ad5b63bde8db2545f3b7d34267f/app/toast/Constants.java#L202-L207
  return ['CN', 'XX'].includes(state) ? '' : state
}

export function formatRestaurantAddress(location: LocationParam): string {
  const normalizedState = normalizeState(location.state)
  const addressParts = [
    location.address1,
    location.address2,
    location.city,
    normalizedState
  ]
  return `${addressParts.filter(Boolean).join(', ')} ${location.zipcode}`
}

export function generateRestaurantAddressQuery(
  restaurantName: string,
  location: LocationParam
): string {
  const formattedAddress = formatRestaurantAddress(location)
  return new URLSearchParams({
    q: `${restaurantName}, ${formattedAddress}`
  }).toString()
}

/**
 * Strips a concatenated "<rxName> <rxName>" down to a
 * single copy of the name; any other name is returned unchanged. It
 * collapses only when the name starts with the rx name and the remainder
 * (ignoring a separating space/comma) is the rx name again.
 *
 * This is intended to be applied to rx names where the business name and the
 * location name have already been concatenated, but should continue to be a
 * safe no-op if given a raw business name.
 */
export function getDisplayBusinessName(
  fullName?: string | null,
  locationName?: string | null
): string | undefined {
  const name = fullName?.trim()
  if (!name) {
    return undefined
  }
  const location = locationName?.trim()
  if (location) {
    const lowerLocation = location.toLowerCase()
    if (name.toLowerCase().startsWith(lowerLocation)) {
      const remainder = name.slice(location.length).replace(/^[\s,]+/, '')
      if (remainder.toLowerCase() === lowerLocation) {
        return location
      }
    }
  }
  return name
}
